import { Dropdown } from 'bootstrap';

const CAPS_Dropdown = {
  init() {
    this.setAnimations();
    this.openOnHover();
  },

  setAnimations() {
    window.addEventListener('show.bs.dropdown', (el) => {
      const animation = el.target.hasAttribute('data-bs-dropdown-animation');
      if (!animation) {
        return;
      }

      const menu = el.target.nextElementSibling;
      menu.style.opacity = 0;
      setTimeout(() => {
        menu.style.transform = `${menu.style.transform} translateY(10px)`;
      });
      setTimeout(() => {
        menu.style.transform = `${menu.style.transform} translateY(-10px)`;
        menu.style.transition = 'transform 300ms, opacity 300ms';
        menu.style.opacity = 1;
      }, 100);
    });

    window.addEventListener('hide.bs.dropdown', (el) => {
      const animation = el.target.hasAttribute('data-bs-dropdown-animation');
      if (!animation) {
        return;
      }

      const menu = el.target.nextElementSibling;
      setTimeout(() => {
        menu.style.removeProperty('transform');
        menu.style.removeProperty('transition');
      });
    });
  },

  openOnHover() {
    const $targets = Array.from(document.querySelectorAll('[data-bs-open-on-hover]'));

    $targets.forEach(($target) => {
      var timeout;
      const instance = new Dropdown($target);

      const close = () => {
        timeout = setTimeout(() => {
          instance.hide();
        }, 500);
      };

      const clearCloseTimeout = () => {
        clearTimeout(timeout);
      };

      $target.addEventListener('mouseenter', () => {
        clearCloseTimeout();
        instance.show();
      });

      instance._menu.addEventListener('mouseenter', () => {
        clearCloseTimeout();
      });

      [$target, instance._menu].forEach(($el) => {
        $el.addEventListener('mouseleave', close);
      });
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  // Ensure CAPS_Dropdown is defined and imported correctly
  if (typeof CAPS_Dropdown === 'undefined') {
    console.error('CAPS_Dropdown is not defined.');
  } else if (typeof CAPS_Dropdown.init !== 'function') {
    console.error('CAPS_Dropdown.init is not a function.');
  } else {
    // Initialize the dropdown
    try {
      CAPS_Dropdown.init();
    } catch (error) {
      console.error('Error initializing CAPS_Dropdown:', error);
    }
  }
});
